import React from "react";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import IBwaiting from "@frameworks/web/assets/images/features/TOC/Common/IBwaiting.svg";
import { Col, Row } from "react-bootstrap";
var IBNotePage = function () {
    return (React.createElement(GridContainer, { parentClass: "error-block-state text-center pb-150 pt-100 bg_white" },
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12, className: "taCenter pt-30 pb-30  mgt-25" },
                React.createElement("img", { src: IBwaiting }))),
        React.createElement(Row, null,
            React.createElement(Col, { lg: 12 },
                React.createElement("div", { className: "DMSan_23_700 txt_blackOne1 mgt-25" }, "Payment In Process"),
                React.createElement("div", { className: "DMSanN_16_400 txt_blackOne1" }, "Please complete the payment in the pop up window that has opened")))));
};
export default IBNotePage;
